const currentUrl = window.location.href;
const sliderLP = document.querySelectorAll('.categ-2025__cta .categ-link');
const slider = document.querySelector('.freescroll');

// Add '-active' class to the button matching the current URL
sliderLP.forEach(button => {
      const buttonUrl = button.getAttribute('href');
      if (currentUrl === buttonUrl) {
            button.querySelector('.btn.btn-secondary').classList.add("-active");

            // Center the active button in mobile view
            setTimeout(() => {
                  if (window.innerWidth < 1024) {
                        const scrollPosition = button.offsetLeft - (slider.offsetWidth - button.offsetWidth) / 2;
                        slider.scrollLeft = scrollPosition;
                  }
            }, 50);
      }
});

// Highlight the "Tout voir" button if no other button is active
const mainCTA = document.querySelector('.categ-2025__cta .categ-link');
if (mainCTA && !document.querySelector('.categ-2025__cta .btn.btn-secondary.-active')) {
      mainCTA.querySelector('.btn.btn-secondary').classList.add("-active");
}

// Function to stop the animation
const stopAnimation = () => {
      slider.classList.add('stop-anim'); // Add a class to stop the animation
      document.cookie = "stop-anim=true; max-age=300"; // Cookie expires in 5 minutes
};

// Check if the "stop-anim" cookie exists
const isAnimationStopped = document.cookie.split('; ').some(cookie => cookie.startsWith('stop-anim='));

// If the animation has not been stopped, add event listeners for scroll and touchstart
if (!isAnimationStopped) {
      const interactionHandler = () => {
            stopAnimation(); // Stop the animation
            // window.removeEventListener('scroll', interactionHandler); // Remove scroll listener
            window.removeEventListener('touchstart', interactionHandler); // Remove touchstart listener
      };

      // Add event listeners for scroll and touchstart
      // window.addEventListener('scroll', interactionHandler, {once: true });
      window.addEventListener('touchstart', interactionHandler, { once: true });
}

// Read the cookie to disable animation if previously set
if (document.cookie.includes("stop-anim=true")) {
      slider.classList.add('stop-anim');
}
